import { FC, useState } from "react";
import { Stack, Text, Title } from "@mantine/core";
import { NewPasswordForm } from "../../features/new-password/NewPasswordForm";
import { useTranslation } from "react-i18next";

import { PasswordUpdatedPage } from "../../pages/password-updated/PasswordUpdated";

interface Props {
  token: string;
}

export const NewPasswordWidget: FC<Props> = ({ token }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(1);

  return (
    <Stack align="stretch" justify="center" gap="24px">
      {step === 1 ? (
        <>
          <Title size={36}>{t("new_password_title")}</Title>
          <Text c="dimmed" size="md">
            {t("new_password_description")}
          </Text>
          <NewPasswordForm token={token} setStep={setStep} />
        </>
      ) : (
        <PasswordUpdatedPage />
      )}
    </Stack>
  );
};
